import { Observable } from "rxjs";

/**
 * Interfície con los métodos de la API del back-end.
 *
 * @export
 * @interface IAPIMethods
 */
export interface IAPIMethods{


    /**
     * Implementa la api cambiarOperario.
     *
     * @param {string} operator
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    cambiarOperario(operator: string): Observable<any>;

    /**
     * Implementa la api cambiarOf.
     *
     * @param {string} mo
     * @param {string} operator
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    cambiarOf(mo: string, operator: string, coord: string): Observable<any>;


    /**
     * Implementa la api entrarOperario.
     *
     * @param {string} operator
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    entrarOperario(operator: string, coord: string): Observable<any>;

    /**
     * Implementa la api salirOperario.
     *
     * @param {string} operator
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    salirOperario(operator: string, coord: string): Observable<any>;


    /**
     * Implementa la api listaOfsInternas.
     *
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    listaOfsInternas(): Observable<any>;


    /**
     * Implementa la api getProductosOfDropdown.
     *
     * @param {string} of El código de la orden de fabricación.
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    getProductosOfDropdown(of: string): Observable<any>;


    /**
     * Implementa la api getOpsProdOfDropdown.
     *
     * @param {string} product El código de producto.
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    getOpsProdOfDropdown(product: string): Observable<any>;


    /**
     * Implementa la api getOfsOperario.
     *
     * @param {string} operator El código del operario.
     * @param {string} date La fecha en formato YYYY-MM-DD.
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    getOfsOperario(operator: string, date: string): Observable<any>;

    /**
     * Implementa la api getInformeTest.
     *
     * @param {string} date1 La fecha en formato YYYY-MM-DD.
     * @param {string} date2 La fecha en formato YYYY-MM-DD.
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    getInformeTest(date1: string, date2: string): Observable<any>;

    /**
     * Implementa la api modHorasOpProdOf.
     *
     * @param {string} register El id de registro a modificar.
     * @param {*} clockIng Los parámetros necesarios.
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    modHorasOpProdOf(register: string, clockIng: any): Observable<any>;


    /**
     * Implementa la api anadirHorasProdOf.
     *
     * @param {*} clockIng
     * @returns {Observable<any}
     * @memberof IAPIMethods
     */
    anadirHorasOpProdOf(clockIng: any): Observable<any>;

    /**
     * Implementa la api delHorasOpProdOf.
     *
     * @param {string} register
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    delHorasOpProdOf(register: string): Observable<any>;

    /**
     * Implementa la api getParams.
     *
     * @returns {Observable<an>}
     * @memberof IAPIMethods
     */
    getParams(): Observable<any>;


    /**
     * Implementa la api getLogo.
     *
     * @returns {Observable<an>}
     * @memberof IAPIMethods
     */
    getLogo(): Observable<any>;

    /**
     * Implementa la api de login.
     *
     * @param {{username:string, password:string}} credentials
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    login(credentials: {username:string, password:string}): Observable<any>;

    /**
     * Implementa la api de operario.
     *
     * @param {string} operator El id del operario.
     * @returns {Observable<any>}
     * @memberof IAPIMethods
     */
    operario(operator: string): Observable<any>;

}


/**
 * Interfície de los métodos para la conexión al back-end.
 * Incluye los métodos de la API.
 *
 * @export
 * @interface IConnection
 * @extends {IAPIMethods}
 */
export interface IConnection extends IAPIMethods{

    /**
     * Contiene el tipo de conexión
     *
     * @type {string}
     * @memberof IConnection
     */
    type: string;


    /**
     * Devuelve el tipo de conexión
     *
     * @returns {string} El tipo de conexión
     * @memberof IConnection
     */
    getType(): string;


    /**
     * Establece el token de autenticación.
     *
     * @param {string} token String con el token de validación.
     * @memberof IConnection
     */
    setToken(token: string);

    /**
     * @ignore
     */
    getOperators(): Observable<Array<any>>;


}


/**
 * Clase para realizar la conexión al back-end.
 *
 * @export
 * @class Connection
 * @implements {IAPIMethods}
 */
export class Connection implements IAPIMethods{


    /**
     * Instanciación para almacenar la classe Connection.
     *
     * @type {IConnection}
     * @memberof Connection
     */
    target: IConnection;



    /**
     * Crea la instancia de Connection.
     *
     * @param {IConnection} target
     * @memberof Connection
     */
    constructor(target: IConnection) {
        this.target = target;
    }


    /**
     * Devuelve el tipo de la conexión.
     *
     * @returns {string}
     * @memberof Connection
     */
    public getType(): string{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará el cambio de operario.
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public cambiarOperario(operator: string = ''): Observable<any>{
        throw new Error("This method is abstract!");
    }


    /**
     * Método abstracto que implementará el cambio de orden de fabricación.
     *
     * @param {string} [mo='']
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public cambiarOf(mo: string = '', operator: string = '', coord: string = ''): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la entrada de operario.
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public entrarOperario(operator: string = '', coord: string = ''): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la saida de operario.
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public salirOperario(operator: string = '', coord: string = ''): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la consulta a la lista interna de OFs.
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public listaOfsInternas(): Observable<any>{
        throw new Error("This method is abstract!");
    }


    /**
     * Método abstracto que implementará la consulta a la lista de fichadas por operario/dia.
     *
     * @param {string} [operator=''] El código del operador
     * @param {string} [date=''] La fecha en formato YYYY-MM-DD
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public getOfsOperario(operator: string = '', date: string = ''): Observable<any>{
        throw new Error("This method is abstract!");
    }

     /**
     * Método abstracto que implementará la consulta a la lista de fichadas por operario/dia.
     *
     * @param {string} [date1=''] La fecha en formato YYYY-MM-DD
     * @param {string} [date2=''] La fecha en formato YYYY-MM-DD
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public getInformeTest(date1: string = '', date2: string = ''): Observable<any>{
      throw new Error("This method is abstract!");
      //alert ("metode abstracte");
    }
    

    /**
     * Método abstracto que implementará la consulta a productos de una OF.
     *
     * @param {string} [of=''] El código de la orden de fabricación
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public getProductosOfDropdown(of: string = ''): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la consulta de operaciones de un producto.
     *
     * @param {string} product El código del producto
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public getOpsProdOfDropdown(product: string): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la consulta de modificación de horas.
     *
     * @param {string} register El id del registro a modificar
     * @param {*} clockIng Los parámteros necesarios
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public modHorasOpProdOf(register: string, clockIng: any): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la consulta de añadir horas.
     *
     * @param {*} clockIng Los parámetros necesarios
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public anadirHorasOpProdOf(clockIng: any): Observable<any>{
        throw new Error("This method is abstract!");
    }


    /**
     * Método abstracto que implementará la consulta para eliminar registros.
     *
     * @param {string} register El id del registro a eliminar
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public delHorasOpProdOf(register: string): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la consulta para recuperar los parámetros de sistema.
     *
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public getParams(): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la consulta para recuperar el logo.
     *
     * @returns {Observable<any>}
     * @memberof Connection
     */
    public getLogo(): Observable<any>{
        throw new Error("This method is abstract!");
    }

    /**
     * Método abstracto que implementará la petición de login.
     *
     * @returns {Observable<Array<string>>}
     * @memberof Connection
     */
    public login(credentials: {username:string, password:string}): Observable<Array<string>>{
        throw new Error("This method is abstract!");
    }

     /**
     * Método abstracto que implementará la petición de operario.
     *
     * @returns {Observable<Array<string>>}
     * @memberof Connection
     */
    public operario(operator: string): Observable<Array<string>>{
        throw new Error("This method is abstract!");
    }

    /**
     * Establece el token de autenticación
     *
     * @param {stirng} [token='']
     * @memberof Connection
     */
    public setToken(token: string = ''){
        throw new Error("This method is abstract!");
    }

    /**
     * @ignore
     *
     * @returns {Observable<Array<string>>}
     * @memberof Connection
     */
    public getOperators(): Observable<Array<string>>{
        throw new Error("This method is abstract!");
    }


}



// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/connection/connection.ts